import React, { useState } from "react";
import { Container, Wrapper } from "./style";
import { useNavigate, useParams } from "react-router";
import { useSelector } from "react-redux";
import { selectLanguage } from "redux/reducers/languageReducer";
import { axiosInstance } from "api";
import { useQuery } from "react-query";
import Loading from "components/Loading";
const Com1 = ({ menu }) => {
  const [title, setTitle] = useState(null);
  const nav = useNavigate();
  const clickHandler = () => {
    nav("/support");
  };
  const { supportId, menuIndex } = useParams();
  const language = useSelector(selectLanguage);

  const { data: supportData, isLoading, isSuccess } = useQuery("supports", () => axiosInstance.get("/support"));

  if (isLoading) return <Loading />;

  return (
    <Wrapper>
      <Container>
        {isSuccess &&
          supportData.data.map((v) => {
            if (v.id.toString() === supportId) return <span key={v.id}>{language === "en" ? v.title : v.titleKR}</span>;
          })}
        <div>
          <img loading="lazy" src="/assets/img/Support_9.svg" alt="" onClick={clickHandler} />
          <img loading="lazy" src="/assets/img/Support_10.svg" alt="" />
          {isSuccess &&
            supportData.data.map((v) => {
              if (v.id.toString() === supportId)
                return <span key={v.id}>{language === "en" ? v.title : v.titleKR}</span>;
            })}
          <img loading="lazy" src="/assets/img/Support_10.svg" alt="" />
          {menu?.data[0] && (
            <span>{language === "en" ? menu?.data[menuIndex].title : menu?.data[menuIndex].titleKR}</span>
          )}
        </div>
      </Container>
    </Wrapper>
  );
};

export default Com1;
